import { legacyEventName, legacyEventProperties } from '@highlight/analytics'

import { createBrowserRuntimeAnalytics } from './browser-analytics'

const DEVICE_ID_KEY = 'highlight_amplitude_device_id'

const getOrCreateDeviceId = (): string => {
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY)
    if (stored) return stored
    const id = crypto.randomUUID()
    localStorage.setItem(DEVICE_ID_KEY, id)
    return id
  } catch {
    return crypto.randomUUID()
  }
}

export const ensureAmplitudeShim = (): void => {
  if (window.ampltd) return

  const analytics = createBrowserRuntimeAnalytics(getOrCreateDeviceId())

  /**
   * The one door every browser-runtime event goes through, to PostHog only;
   * Amplitude is disconnected.
   *
   * Person properties are dropped. They would mean `identify()`, which on a
   * signed-out visitor marks that anonymous id identified and silently makes
   * the real sign-in merge illegal, per
   * ../../../../../.cursor/rules/analytics.mdc.
   */
  const trackEvent = (eventName: string, eventProps?: Record<string, any>) => {
    analytics.capture(legacyEventName(eventName), legacyEventProperties(eventProps))
  }

  window.ampltd = {
    trackEvent,
    trackSettingUpdate: (setting: string, value: any, eventProperties?: Record<string, any>) => {
      trackEvent('Setting Update', { setting, value, ...(eventProperties ?? {}) })
    },
    setUserProperties: () => {},
    incrementUserProperty: () => {},
    flushAmplitude: async () => {},
  }
}
